import { render, staticRenderFns } from "./IndexElaryWarningInfo.vue?vue&type=template&id=065c2dea&"
import script from "./IndexElaryWarningInfo.vue?vue&type=script&lang=js&"
export * from "./IndexElaryWarningInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports